import { ACTIONS_FROM_UNIFIED_INBOX } from '../../constants';
import ACDIcon001 from '../../Images/OldCampIcons/001.png'
import ACDIcon002 from '../../Images/OldCampIcons/002.png'
import ACDIcon003 from '../../Images/OldCampIcons/003.png'
import ACDIcon004 from '../../Images/OldCampIcons/004.png'
import ACDIcon005 from '../../Images/OldCampIcons/005.png'
import ACDIcon006 from '../../Images/OldCampIcons/006.png'
import ACDIcon007 from '../../Images/OldCampIcons/007.png'
import ACDIcon008 from '../../Images/OldCampIcons/008.png'
import ACDIcon009 from '../../Images/OldCampIcons/009.png'
import ACDIcon010 from '../../Images/OldCampIcons/010.png'
import ACDIcon011 from '../../Images/OldCampIcons/011.png'
import ACDIcon012 from '../../Images/OldCampIcons/012.png'
import ACDIcon013 from '../../Images/OldCampIcons/013.png'
import ACDIcon014 from '../../Images/OldCampIcons/014.png'
import ACDIcon015 from '../../Images/OldCampIcons/015.png'
import ACDIcon016 from '../../Images/OldCampIcons/016.png'
import ACDIcon017 from '../../Images/OldCampIcons/017.png'
import ACDIcon018 from '../../Images/OldCampIcons/018.png'
import ACDIcon019 from '../../Images/OldCampIcons/019.png'
import ACDIcon020 from '../../Images/OldCampIcons/020.png'
import ACDIcon021 from '../../Images/OldCampIcons/021.png'
import ACDIcon022 from '../../Images/OldCampIcons/022.png'
import ACDIcon023 from '../../Images/OldCampIcons/023.png'
import ACDIcon024 from '../../Images/OldCampIcons/024.png'
import ACDIcon025 from '../../Images/OldCampIcons/025.png'
import ACDIcon026 from '../../Images/OldCampIcons/026.png'
import ACDIcon027 from '../../Images/OldCampIcons/027.png'
import ACDIcon028 from '../../Images/OldCampIcons/028.png'
import ACDIcon029 from '../../Images/OldCampIcons/029.png'
import ACDIcon030 from '../../Images/OldCampIcons/030.png'
import ACDIcon031 from '../../Images/OldCampIcons/031.png'
import ACDIcon032 from '../../Images/OldCampIcons/032.png'

const ACDImageCatalog = {
   1: ACDIcon001,
   2: ACDIcon002,
   3: ACDIcon003,
   4: ACDIcon004,
   5: ACDIcon005,
   6: ACDIcon006,
   7: ACDIcon007,
   8: ACDIcon008,
   9: ACDIcon009,
   10: ACDIcon010,
   11: ACDIcon011,
   12: ACDIcon012,
   13: ACDIcon013,
   14: ACDIcon014,
   15: ACDIcon015,
   16: ACDIcon016,
   17: ACDIcon017,
   18: ACDIcon018,
   19: ACDIcon019,
   20: ACDIcon020,
   21: ACDIcon021,
   22: ACDIcon022,
   23: ACDIcon023,
   24: ACDIcon024,
   25: ACDIcon025,
   26: ACDIcon026,
   27: ACDIcon027,
   28: ACDIcon028,
   29: ACDIcon029,
   30: ACDIcon030,
   31: ACDIcon031,
   32: ACDIcon032,

}


export const showUnifiedMessagesWindow = (show) => ({ type: ACTIONS_FROM_UNIFIED_INBOX.SHOW, show })

export const endConversationChat = (message) => ({ type: ACTIONS_FROM_UNIFIED_INBOX.CHAT_CUSTOMER_TERMINATION, conversationId: message.ConversationID, campType: message.CampType != null ? message.CampType : 0 })
export const endConversationClient = (message, clientTermination) => ({ type: ACTIONS_FROM_UNIFIED_INBOX.CHAT_CLIENT_DISCONNECT, conversationId: message.ConversationID, clientTermination, campType: message.CampType != null ? message.CampType : 0 })


export const newUnifiedInboxConversation = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.NEW_CONVERSATION[message.ServiceType],
   conversationId: message.ConversationId,
   acdId: message.acdID,
   acdName: message.ACDName,
   image: ACDImageCatalog[message.ACDGraphicId],
   name: message.ClientName,
   accountMail: message.InboundEmail,
   account: message.ServiceType === 3 ? '@' + message.ClientAddress : message.ClientAddress,
   photo: undefined,
   initialTime: new Date(),
   showWrapUp: message.showWrapUp,
   wrapUpTime: message.WrapUpTime,
   content: message.EmailMessagesList,
   timeoutWarning: message.AlertMessageTime,
   timeout: message.AnswerTimeOut,
   TwitterMessagesList: message.TwitterMessagesList,
   senderName: message.SenderName,
   IsAzure: message.IsAzure,
   origin: message.origin,
   campType: message.CampType
})

export const chatTyping = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.TYPING,
   conversationId: message.ConversationID,
   campType: message.CampType != null ? message.CampType : 0,
   typing: message.ShowAnimation
})

export const chatAnswersTemplates = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.ANSWERS_TEMPLATES_CHAT,
   conversationId: message.ConversationId,
   answers: message.answers,
   maxImgChat: message.maxImgChat,
   campType: message.CampType != null ? message.CampType : 0
})

export const chatTakeover = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.CHAT_TAKEOVER,
   conversationId: message.ConversationID,
   takeover: message.takeover,
   campType: message.CampType != null ? message.CampType : 0
})

export const newUnifiedInboxMessage = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.NEW_MESSAGE_INBOX[message.ServiceType],
   conversationId: message.ConversationId,
   content: message.Message,
   origin: message.origin ? message.origin : 'AGENT',
   date: new Date(),
   subject: message.Subject,
   media: message.Type ? message.Type : 'Text',
   campType: message.CamType != null ? message.CamType : 0
})
export const newUnifiedInboxExternalMessage = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_MESSAGING_CUSTOMER,
   conversationId: message.externalMessagingCustomerDto.ConversationID,
   name: message.externalMessagingCustomerDto.ClientId,
   AgentId: message.externalMessagingCustomerDto.AgentId,
   ConversationState: message.externalMessagingCustomerDto.ConversationState,
   account: message.externalMessagingCustomerDto.To,
   serviceType: message.externalMessagingCustomerDto.ServiceType,
   campaign: message.externalMessagingCustomerDto.Campaign,
   clientTermination: message.externalMessagingCustomerDto.ClientTermination,
   initialTime: new Date(),
   totalTime: 0,
   content: message.externalMessagingCustomerDto.Messages,
   image: ACDImageCatalog[message.externalMessagingCustomerDto.Campaign.ACDGraphicId],
   showWrapUp: message.externalMessagingCustomerDto.Campaign.ShowCalifWnd,
   to: message.externalMessagingCustomerDto.To,
   from: message.externalMessagingCustomerDto.From,
   SecTimeOutLastMessageAgent: message.externalMessagingCustomerDto.SecTimeOutLastMessageAgent,
   allowUnassign: message.externalMessagingCustomerDto.AllowUnassign,
   allowSpam: message.externalMessagingCustomerDto.AllowSpam,
   lastConversations: message.externalMessagingCustomerDto.LastConversations
})
export const alertMessageErrorMMC = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_MESSAGE_ERROR_MMC,
	value: message.value
});
export const newUnifiedInboxExternalNewMessage = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.EXTERNAL_NEW_MESSAGING,
	conversationId: message.ConversationID,
	origin: message.Origin,
	content: message.Content,
	date: message.Date ? message.Date : new Date(),
   messageId: message.UIMessageId,
   status: message.statusMesage ? message.statusMesage : '',
   messagesList: message.messagesList,
   MessageType: message.MessageType,
   Attachments: message.Attachments,
   campType: message.CampType != null ? message.CampType : message.CamType != null ? message.CamType : 0,
   graphicId: message.GraphicId,
});
export const changeStateExternalMessage = (message) =>({
   type: message.subAction,
   conversationId: message.ConversationID,
   unreadMessage: message.unreadMessage,
   campType: message.campType
});
export const changeStateMessage = (message) => ({
   type: message.subAction,
   conversationId: message.ConversationID,
   messageId: message.messageUIID,
   status: message.statusMessage === 'submitted' ? 'send' : message.statusMessage === 'rejected' || message.statusMessage === 'undeliverable' ? 'error' : message.statusMessage,
   campType: message.CampType != null ? message.CampType : 0 
});
export const selectConversation = (campType, selectedID) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.SELECT_CONVERSATION,
   campType,
   selectedID
})

export const setMultimediaDispositions = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.MULTIMEDIA_DISPOSITION,
   conversationId: message.ConversationId,
   dispositions: message.DispositionList,
   campType: message.CampType != null ? message.CampType : 0 
})
export const firstCallNewPreview = (dataCall) => ({
   CamId: dataCall.CamId,
   CallKey: dataCall.CallKey,
   Phone: dataCall.Telephone ,
   Data: dataCall.Data,
   ExistsCallout: 0,
   CallMode: 2
})

export const changeStateMultimedia = (message) => ({type: ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA, data: message.data});
export const changeStateMultimediaAll = (message) => ({type: ACTIONS_FROM_UNIFIED_INBOX.CHANGE_STATE_MULTIMEDIA_ALL, data: message.data});

export const conversationTimeoutReached = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.CONVERSATION_TIMEOUT_REACHED,
   conversationId: message.ConversationID,
   campType: message.CampType != null ? message.CampType : 0
})

export const endConversationsCampaignDeleted = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.END_CONVERSATIONS_CAMPAIGN_DELETED,
   conversationIds: message.ConversationIDs,
   campType: message.CampType
})

export const updateConvsDeletedByError = () => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVS_DELETED_BY_ERROR
})

export const  fetchingConversation = (message) => ({
    type: ACTIONS_FROM_UNIFIED_INBOX.FETCHING_CONVERSATION,
    conversationId: message.id,
    fetching: message.fetching,
    campType: message.campType
})

export const newHistoricalConversation = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.NEW_HISTORICAL_CONVERSATION,
   lastConversationId: message.Data.LastConversationId,
   lastConversation: message.Data.LastConversation,
   conversationId: message.Data.ConversationID,
   campType: message.Data.CampType != null ? message.Data.CampType : 0
})

export const errorOnHistoricalConversation = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.ERROR_HISTORICAL_CONVERSATION,
   errorCode: message.Data.ResponseCode,
   errorDescription: message.Data.ResponseCodeDescription,
   lastConversationId: message.Data.LastConversationId,
   conversationId: message.Data.ConversationID,
   campType: message.Data.CampType,
   isAllConversations: message.Data.IsAllConversations
})

export const resetTimeout = (data) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.RESET_TIMEOUT,
   conversationId: data.conversationId,
   campType: data.campType
})

export const updatePermissions = (permissionName, permissionValue) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.UPDATE_PERMISSION,
   permissionName,
   permissionValue
})

export const createDraftMessage = (id) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.NEW_DRAFT_MESSAGE,
   id
})

export const updateDraftMessage = (id, data) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_MESSAGE,
   id,
   data
})

export const updateDraftAttachments = (id, data) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.UPDATE_DRAFT_ATTACHMENTS,
   id,
   data
})

export const deleteDraftMessage = (id) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.DELETE_DRAFT_MESSAGE,
   id
})

export const updateConversationsPhoneChange = (message) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.UPDATE_CONVERSATIONS_PHONE_CHANGE,
   conversationIds: message.ConversationIDs,
   campType: message.CampType
})

export const chatConversationRead = (campType, idConversation) => ({
   type: ACTIONS_FROM_UNIFIED_INBOX.CHAT_CONVERSATION_READ,
   idConversation,
   campType
})


// WEBPACK FOOTER //
// ./src/redux/actions/A_actions_UnifiedInbox.js